export const supportsCameraBarcodeScan = () => {
  return typeof navigator !== "undefined"
    && Boolean(navigator.mediaDevices?.getUserMedia)
    && typeof window !== "undefined"
    && "BarcodeDetector" in window;
};


export const createCameraBarcodeSession = async ({ videoElement, onDetect }) => {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: { facingMode: { ideal: "environment" } },
    audio: false,
  });

  videoElement.srcObject = stream;
  await videoElement.play();

  const detector = new window.BarcodeDetector({ formats: ["ean_13", "ean_8", "code_128", "qr_code"] });
  let frameHandle = null;
  let active = true;

  const stop = () => {
    active = false;
    if (frameHandle) {
      cancelAnimationFrame(frameHandle);
      frameHandle = null;
    }
    stream.getTracks().forEach((track) => track.stop());
  };

  const scanFrame = async () => {
    if (!active || videoElement.readyState < 2) {
      frameHandle = requestAnimationFrame(scanFrame);
      return;
    }

    const codes = await detector.detect(videoElement);
    const rawValue = codes?.[0]?.rawValue;
    if (rawValue) {
      stop();
      await onDetect(rawValue);
      return;
    }

    frameHandle = requestAnimationFrame(scanFrame);
  };

  frameHandle = requestAnimationFrame(scanFrame);
  return { stop };
};